const tosSection = $('#list-section');
const tosMenuGroups = tosSection.find('.float-menu-group');
const tosMenuLinks = tosSection.find('.float-menu-point-anchor');
const tosMenuGropusLenis = [];
const mobileBg = $('.list-float-menu-bg');
const mobileMenuParent = $('.list-float-menu');
const mobileMenuMini = mobileMenuParent.find('.float-menu-mobile-mini');
const mobileMenuFull = mobileMenuParent.find('.float-menu-mobile-full');
let lastActiveGroup = undefined;
let lastActiveLink = undefined;
const tosMenuGroupsST = [];
const tosMenuLinksST = [];

const toggleMenuAnimation = () => {
  const menuTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      lenis.stop();
    },
    onReverseComplete: () => {
      lenis.start();
    },
  });
  menuTL.add(
    gsap.fromTo(
      mobileMenuMini,
      {
        opacity: 1,
        backdropFilter: 'blur(40px)',
      },
      {
        opacity: 0,
        backdropFilter: 'blur(0px)',
        duration: 0.33,
        ease: 'opacityInEasing',
      }
    ),
    0
  );
  menuTL.add(
    gsap.fromTo(
      mobileMenuFull,
      {
        y: '100%',
      },
      {
        y: 0,
        duration: 0.83,
        ease: 'pageInEasing',
      }
    ),
    0.33
  );
  menuTL.add(
    gsap.fromTo(
      mobileBg,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.83,
        ease: 'pageInEasing',
        onComplete: () => {
          gsap.set(mobileBg, { pointerEvents: 'all' });
        },
        onReverseComplete: () => {
          gsap.set(mobileBg, { pointerEvents: 'none' });
        },
      }
    ),
    0.33
  );

  return menuTL;
};

const initMobileMenu = () => {
  const mobileBackBtn = mobileMenuFull.find('.float-menu-mobile-back-btn');
  const mobileMenuList = mobileMenuFull.find('.float-menu-mobile-list');
  const mobileMenuListInner = mobileMenuFull.find('.tos-float-menu-mobile-inner-list-placer');
  const mobileugMenuGroups = mobileMenuList.find('.tos-list-type-parent-mobile');
  const mobileMenuInnerLinksAll = mobileMenuFull.find('.tos-type-group-mobile');
  const mobileMenuDownloadBtn = mobileMenuParent.find('.float-menu-btn-placer');

  mobileMenuListInner.each(function () {
    const menuItemLenis = new Lenis({
      wrapper: $(this).get(0),
      autoRaf: true,
    });
  });

  const menuLenis = new Lenis({
    wrapper: mobileMenuList.get(0),
    autoRaf: true,
  });

  const menuTL = toggleMenuAnimation();

  const toggleMenuFull = (open) => {
    if (open) {
      menuTL.play();
    } else {
      menuTL.reverse();
    }
  };

  const toggleList = (open) => {
    mobileMenuList.css('display', open ? 'flex' : 'none');
    mobileMenuListInner.css('display', open ? 'none' : 'flex');
  };

  const toggleBackBtn = (open) => {
    mobileBackBtn.css('display', open ? 'flex' : 'none');
  };

  mobileMenuMini.on('click', function (e) {
    e.stopPropagation();
    toggleMenuFull(true);
  });

  mobileBg.on('click', function (e) {
    e.stopPropagation();
    toggleMenuFull(false);
  });

  mobileMenuFull.on('click', function (e) {
    e.stopPropagation();
  });

  mobileBackBtn.on('click', function (e) {
    mobileMenuListInner.html('');
    toggleList(true);
    toggleBackBtn(false);
  });

  mobileMenuInnerLinksAll.on('click', function (e) {
    lenis.start();
    toggleMenuFull(false);
    toggleList(true);
    toggleBackBtn(false);
    mobileMenuListInner.html('');
  });

  mobileugMenuGroups.each(function () {
    $(this).on('click', function () {
      const innerListItmes = $(this).find('.tos-float-menu-mobile-inner-list .tos-type-group-mobile');
      mobileMenuListInner.append(innerListItmes.clone(true));
      toggleList(false);
      toggleBackBtn(true);
    });
  });
};

function changeActiveLink(toLink, isByTrigger = false) {
  const parentGroupIndex = toLink.closest('.float-menu-group').index() - 1;
  if (lastActiveLink == toLink) return;
  if (lastActiveLink != undefined) {
    lastActiveLink.toggleClass('active');
  }
  if (isByTrigger) {
    tosMenuGropusLenis[parentGroupIndex].scrollTo(toLink.get(0), { offset: -vwToPx(2.5) });
  }
  toLink.toggleClass('active');
  lastActiveLink = toLink;
}

const setGroups = () => {
  tosMenuGroups.each(function (index) {
    const groupTopper = $(this).find('.float-menu-group-topper');
    const groupLinkList = $(this).find('.float-menu-group-list');
    const groupTopperHeight = pxToVw(groupTopper.outerHeight());
    tosMenuGropusLenis[index] = new Lenis({
      wrapper: groupLinkList.get(0),
      autoRaf: true,
    });
    gsap.set($(this), { height: `${groupTopperHeight}vw` });
  });
};

const toggleGroupAnimation = (group, direction) => {
  const groupTopper = group.find('.float-menu-group-topper');
  const groupInner = group.find('.float-menu-group-list');
  const groupTopperHeight = pxToVw(groupTopper.outerHeight());
  const groupInnerHeight = pxToVw(groupInner.outerHeight());
  const toHeight = groupTopperHeight + groupInnerHeight + 0.938;
  gsap.to(group, {
    height: direction ? `${toHeight}vw` : `${groupTopperHeight}vw`,
    duration: 0.63,
    ease: 'pageInEasing',
  });
  gsap.to(groupInner, {
    opacity: direction ? 1 : 0,
    duration: 0.33,
    ease: 'opacityInEasing',
    delay: 0.3,
  });
  direction ? group.addClass('opened') : group.addClass('closed');
};

function changeActiveGroup(toGroup, byTrigger = false) {
  if (toGroup.is(lastActiveGroup) && !byTrigger) {
    toggleGroupAnimation(lastActiveGroup, false);
    lastActiveGroup = undefined;
    return
  }
  if (lastActiveGroup != undefined) {
    toggleGroupAnimation(lastActiveGroup, false);
  }
  toggleGroupAnimation(toGroup, true);
  lastActiveGroup = toGroup;
}

tosMenuGroups.on('click', function () {
  changeActiveGroup($(this));
});

tosMenuLinks.on('click', function () {
  changeActiveLink($(this));
});

const initTosMenuGroups = () => {
  tosMenuGroupsST.forEach((tg) => tg.kill());
  tosMenuGroupsST.length = 0;
  tosMenuGroups.each(function () {
    const firstGroupLink = $(this).find('.float-menu-point-anchor').eq(0);
    const href = firstGroupLink.attr('href').split('_')[0];
    const anchorToElement = tosSection.find(`${href}`);

    if (isDesktop()) {
      tosMenuGroupsST.push(
        ScrollTrigger.create({
          trigger: anchorToElement,
          start: 'top top+=20%',
          end: 'bottom top+=20%',
          onEnter: () => {
            if (!blockTriggers) {
              changeActiveGroup($(this), true);
            }
          },
          onEnterBack: () => {
            if (!blockTriggers) {
              changeActiveGroup($(this), true);
            }
          },
        })
      );
    }
  });
};

const initTosMenuLinks = () => {
  tosMenuLinksST.forEach((tg) => tg.kill());
  tosMenuLinksST.length = 0;

  tosMenuLinks.each(function () {
    const href = $(this).attr('href');
    const anchorToElement = $(href);
    const elementTitle = anchorToElement.find('.list-point-title').text();

    if (isDesktop()) {
      tosMenuLinksST.push(
        ScrollTrigger.create({
          trigger: anchorToElement,
          start: 'top top+=20%',
          end: 'bottom top+=20%',
          onEnter: () => {
            if (!blockTriggers) {
              changeActiveLink($(this), true);
            }
          },
          onEnterBack: () => {
            if (!blockTriggers) {
              changeActiveLink($(this), true);
            }
          },
        })
      );
    } else {
      tosMenuLinksST.push(
        ScrollTrigger.create({
          trigger: anchorToElement,
          start: 'top bottom-=20%',
          end: 'bottom bottom-=20%',
          onEnter: () => {
            console.log();
            $('.float-menu-mobile-mini-label').text(elementTitle);
          },
          onEnterBack: () => {
            $('.float-menu-mobile-mini-label').text(elementTitle);
          },
        })
      );
    }
  });
};

const initTosMenu = () => {
  lenis.start();
  gsap.set([mobileBg, mobileMenuParent, mobileMenuFull], { clearProps: 'all' });
  setGroups();
  if (!isDesktop()) {
    initMobileMenu();
  }
  initTosMenuGroups();
  initTosMenuLinks();

  //changeActiveGroup(tosMenuGroups.eq(lastActiveGroup ? lastActiveGroup : 0));
};

$(window).on('deviceChange', function () {
  initTosMenu();
});

$(window).on('load', function () {
  initTosMenu();
});
